import { render, staticRenderFns } from "./AlignmentDropDownSelector.vue?vue&type=template&id=1c545fff&scoped=true&"
import script from "./AlignmentDropDownSelector.vue?vue&type=script&lang=ts&"
export * from "./AlignmentDropDownSelector.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c545fff",
  null
  
)

export default component.exports